import React, { useEffect, useState } from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useHover from "../hooks/useHover";
import { forArrayLength, objectToArray } from "../misc/helperfuncs";
import boxStore from "../stores/boxStore";
import collectionStore from "../stores/collectionStore";
import MainStore from "../stores/MainStore";
import Counter from "./Counter";
import CounterDescription from "./CounterDescription";
import PointCounterDescription from "../hoverDescriptions/PointCounterDescription";

const Counters = ({ closeBoxTypeArea }) => {
  function makeCounter(
    name,
    count,
    icon,
    hoverDescription,
    onClick,
    secondCounter
  ) {
    return { name, count, icon, hoverDescription, onClick, secondCounter };
  }
  const { player } = MainStore();
  const { boxTypeOverview, addRemoveBoxTypeOverview } = boxStore();
  const { open, history } = collectionStore();
  const { getBoxType } = useHandleBoxTypes();
  const [counters, setCounters] = useState([]);

  function onCounterClicked(name) {
    addRemoveBoxTypeOverview(getBoxType(name, true));
    closeBoxTypeArea();
  }

  useEffect(() => {
    if (player) {
      const c = [];
      c.push(
        makeCounter(
          "checkmarks",
          player?.checkmarks,
          "/icons/icon_checkmark.png",
          null,
          null
        )
      );
      c.push(
        makeCounter(
          "points",
          player?.points.open,
          "/icons/icon_point.png",
          <PointCounterDescription />,
          null
        )
      );
      c.push(
        makeCounter(
          "Trophies",
          player?.trophies.open,
          "/icons/icon_trophy.png",
          null,
          null
        )
      );

      c.push(
        makeCounter(
          "thoughts",
          history?.thoughts.length,
          "/icons/icon_thought.png",
          null,
          null
        )
      );
      c.push(
        makeCounter(
          "reports",
          history?.reports.length,
          "/icons/icon_report.png",
          null,
          null
        )
      );
      c.push(
        makeCounter(
          "changes",
          history?.changes?.length,
          "/icons/icon_change.png",
          null,
          null
        )
      );
      c.push(
        makeCounter(
          "statements",
          open?.statements.length,
          "/icons/icon_statement.png",
          null,
          null
        )
      );

      forArrayLength(objectToArray(player.boxTypes), (boxType) => {
        c.push(
          makeCounter(
            boxType.value.names.plural,
            ["open", boxType.value.names.plural],
            boxType.value.icon,
            <CounterDescription boxType={boxType.value.names.plural} />,
            onCounterClicked
          )
        );
      });
      setCounters(c);
    }
  }, [player]);

  return (
    <div
      style={{
        backgroundColor: "#5f5f5f",
        width: "100%",
        padding: "5px",
        flexWrap: "wrap",
        display: "flex",
        overflow: "auto",
        maxWidth: "100%",
        justifyContent: "space-around",
      }}
    >
      {counters.map((c) => (
        <Counter
          {...c}
          key={c.name}
          selectedOverviews={boxTypeOverview.map((bt) => bt.names.plural)}
        />
      ))}
    </div>
  );
};

export default Counters;
